export default __webpack_public_path__ + "static/media/flavia.736eaa7b.png";